import React from 'react';
import type { PageContextData } from 'c-wrapper/Types/PageContext';

export const PageContext = React.createContext<PageContextData<any>>({ page: null });

export const drawerWidth = 240;
export const navigationInsetShadow = 'inset -6px 0px 25px 10px rgba(62, 62, 62, 0.1)';
